module.exports = __webpack_public_path__ + "static/media/view admission form.6cf50843.svg";